import { useState } from 'react';
import { api } from '../../services/api';
import { useLanguage } from '../../i18n/LanguageContext';

interface DeleteServiceModalProps {
  token: string;
  serviceId: string;
  serviceName: string;
  onClose: () => void;
  onSuccess: () => void;
}

function DeleteServiceModal({ token, serviceId, serviceName, onClose, onSuccess }: DeleteServiceModalProps) {
  const { t } = useLanguage();
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDelete = async () => {
    setDeleting(true);
    setError(null);
    try {
      await api.removeService(serviceId, token);
      onSuccess();
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : t('services.removeFailed'));
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div className="partner-modal-overlay">
      <div className="partner-modal" style={{ maxWidth: '420px' }}>
        <div className="partner-modal-body">
          <div className="partner-delete-modal-content">
            <div className="partner-delete-modal-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                <line x1="10" y1="11" x2="10" y2="17" />
                <line x1="14" y1="11" x2="14" y2="17" />
              </svg>
            </div>

            <h3>{t('services.modal.deleteConfirm')}</h3>
            <p style={{ fontWeight: 500 }}>&ldquo;{serviceName}&rdquo;</p>
            <p>{t('services.modal.deleteWarning')}</p>

            {error && <div className="error-message" style={{ marginBottom: '1rem' }}>{error}</div>}

            <div className="partner-delete-modal-actions">
              <button className="partner-modal-btn-cancel" onClick={onClose}>
                {t('common.cancel')}
              </button>
              <button
                className="partner-modal-btn-danger"
                disabled={deleting}
                onClick={handleDelete}
              >
                {deleting ? t('common.loading') : t('services.modal.yesSure')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteServiceModal;
